import fire from "../../firebase-config";

export default class FirebaseService {

  private static analytics = fire.analytics();

  public static async fetchAndActivateRemoteConfig(): Promise<void> {
    await fire.remoteConfig().fetchAndActivate()
      .then(() => {
      })
      .catch((error) => {
      });
  }

  public static fireEvent(key: string) {
    const env: string = `${process.env.REACT_APP_ENV}`;
    if (env !== 'production') {
      console.log(`>> EVENT: ${key}`);
    }
    this.analytics.logEvent(key);
  }

  public static getValue(key: string): string {
    return fire.remoteConfig().getString(key);
  }

  public static wheel_button = "wheel_button";
  public static wheel_description = "wheel_description";
  public static wheel_error_description = "wheel_error_description";
  public static wheel_error_go_back = "wheel_error_go_back";
  public static wheel_error_title = "wheel_error_title";
  public static wheel_error_try_again = "wheel_error_try_again";
  public static wheel_header = "wheel_header";
  public static wheel_link_exp_button = "wheel_link_exp_button";
  public static wheel_link_exp_description = "wheel_link_exp_description";
  public static wheel_link_exp_title = "wheel_link_exp_title";
  public static wheel_no_right_button1 = "wheel_no_right_button1";
  public static wheel_no_right_button2 = "wheel_no_right_button2";
  public static wheel_no_right_text = "wheel_no_right_text";
  public static wheel_success_button1 = "wheel_success_button1";
  public static wheel_success_button2 = "wheel_success_button2";
  public static wheel_success_description = "wheel_success_description";
  public static wheel_success_title = "wheel_success_title";
  public static wheel_success_title2 = "wheel_success_title2";
}
